module.exports = __webpack_public_path__ + "img/ebm_logo.a7ce8305.png";